import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewPageComponent } from 'src/app/view/pages/view-page/view-page.component';
import { WidgetConfigResolver } from 'src/app/widget-auth/widget-config-resolver';
import { WidgetMasterComponent } from 'src/app/widget/pages/widget-master/widget-master.component';
import { WidgetErrorComponent } from 'src/app/widget/pages/widget-error/widget-error.component';

const routes: Routes = [
  {
    path: '',
    component: WidgetMasterComponent,
    resolve: {
      widgetConfig: WidgetConfigResolver
    },
    children: [
      {
        path: '',
        component: ViewPageComponent,
      },
      {
        path: 'error',
        component: WidgetErrorComponent
      }
  ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [WidgetConfigResolver]
})
export class AppWidgetRoutingModule { }
